import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { DEFAULT_LANGUAGE } from '../constants'

const useLanguage = (lang = DEFAULT_LANGUAGE) => {

    const { t, i18n } = useTranslation()

    useEffect(() => {
        i18n.changeLanguage(lang)

    }, [i18n, lang])

    return { t }
}

export default useLanguage
